import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import styles from './Modal.module.scss';
const Modal = ({ show, onHide, title, children, size = 'md', showCloseButton = true, className = '', backdrop = true, keyboard = true, footer, centered = false, header }) => {
    // Handle escape key
    useEffect(() => {
        const handleEscape = (event) => {
            if (keyboard && event.key === 'Escape' && show) {
                onHide();
            }
        };
        if (show) {
            document.addEventListener('keydown', handleEscape);
            // Prevent body scroll when modal is open
            document.body.style.overflow = 'hidden';
        }
        return () => {
            document.removeEventListener('keydown', handleEscape);
            // Restore body scroll when modal is closed
            document.body.style.overflow = 'unset';
        };
    }, [show, keyboard, onHide]);
    // Handle backdrop click
    const handleBackdropClick = (event) => {
        if (backdrop && event.target === event.currentTarget) {
            onHide();
        }
    };
    if (!show)
        return null;
    const sizeClasses = {
        sm: styles.modalSm,
        md: styles.modalMd,
        lg: styles.modalLg,
        xl: styles.modalXl
    };
    return (_jsx("div", { className: `${styles.modalOverlay} ${className}`, onClick: handleBackdropClick, role: "dialog", "aria-modal": "true", "aria-labelledby": title ? "modal-title" : undefined, children: _jsxs("div", { className: `${styles.modalContent} ${sizeClasses[size]} ${centered ? styles.modalCentered : ''}`, onClick: (e) => e.stopPropagation(), children: [(header || title || showCloseButton) && (_jsx("div", { className: styles.modalHeader, children: header ? (header) : (_jsxs(_Fragment, { children: [title && (_jsx("h5", { className: styles.modalTitle, id: "modal-title", children: title })), showCloseButton && (_jsx("button", { type: "button", className: styles.btnClose, onClick: onHide, "aria-label": "Fechar", children: _jsx("span", { "aria-hidden": "true", children: "\u00D7" }) }))] })) })), _jsx("div", { className: styles.modalBody, children: children }), footer && (_jsx("div", { className: styles.modalFooter, children: footer }))] }) }));
};
export default Modal;
